import Controller, { OnClose } from '@philips-emr/tws-core/lib/client';

import BaseController from '../BaseController';

@Controller({ fragment: 'term-provider-accreditation' })
export default class TermFormProviderAccreditationController extends BaseController {

  @OnClose('panel-term-of-use-main')
  onCloseModal(): void {
    this.historyService.back();
  }

}
